/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import MPPS from './mpps';
import MPPSDetail from './mpps-detail';
import MPPSUpdate from './mpps-update';
import MPPSDeleteDialog from './mpps-delete-dialog';

const MPPSRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<MPPS />} />
    <Route path="new" element={<MPPSUpdate />} />
    <Route path=":id">
      <Route index element={<MPPSDetail />} />
      <Route path="edit" element={<MPPSUpdate />} />
      <Route path="delete" element={<MPPSDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default MPPSRoutes;
